module.exports = __webpack_public_path__ + "img/262.118888d8.jpg";